
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitoaurangabadcab() {



    const cardData =
    {
        keyword: ' Mumbai to Aurangabad Cab ',
        heading: 'Vedant Travels: Mumbai to Aurangabad Cab Service',
        headingDescription: 'Vedant Travels offers a reliable and comfortable Mumbai to Aurangabad cab service, ensuring a smooth and hassle-free journey for travelers. Whether you are visiting the historic Ajanta and Ellora Caves, the grand Bibi Ka Maqbara, or traveling for business, our well-maintained fleet of sedans, SUVs, and luxury cars caters to all travel needs. Our professional drivers ensure a safe and convenient trip with flexible pickup and drop-off options. With 24/7 availability, competitive fares, and an easy online booking system, Vedant Travels makes your Mumbai to Aurangabad journey stress-free and enjoyable.',

        top: 'Top Places to Visit in Aurangabad with Vedant Travels',

"topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "A UNESCO World Heritage Site, the Ajanta Caves are a series of rock-cut Buddhist cave monuments dating back to the 2nd century BCE. These caves feature stunning frescoes, intricate sculptures, and ancient paintings depicting the life of Buddha. The caves are a must-visit for history and art lovers."
    },
    {
        "title": "Ellora Caves",
        "description": "Located about 30 km from Aurangabad, the Ellora Caves are another UNESCO Heritage Site known for their breathtaking rock-cut temples. The most famous structure here is the Kailasa Temple, an architectural marvel carved from a single rock. The site showcases Hindu, Jain, and Buddhist influences, making it a fascinating cultural destination."
    },
    {
        "title": "Bibi Ka Maqbara",
        "description": "Often called the 'Mini Taj Mahal,' Bibi Ka Maqbara was built by Aurangzeb’s son, Azam Shah, in memory of his mother. The monument closely resembles the Taj Mahal and is a beautiful example of Mughal architecture. Visitors can explore its intricately designed marble structure and surrounding gardens."
    },
    {
        "title": "Daulatabad Fort",
        "description": "Perched on a hill, Daulatabad Fort is an impressive 12th-century fortress known for its ingenious defense systems. The fort offers breathtaking views of the surrounding landscape and is a paradise for history enthusiasts and adventure seekers. Visitors can explore its massive gates, secret tunnels, and ancient cannons."
    },
    {
        "title": "Grishneshwar Temple",
        "description": "One of the 12 Jyotirlingas of Lord Shiva, the Grishneshwar Temple is a sacred Hindu site located near Ellora Caves. Devotees from across the country visit this temple to seek blessings and admire its stunning architectural beauty. The temple’s peaceful atmosphere makes it a perfect spiritual retreat."
    },
    {
        "title": "Panchakki",
        "description": "Panchakki, or the Water Mill, is a 17th-century engineering marvel that used water power to grind grains for the local Sufi saints. The site also houses a beautiful garden, a mosque, and a serene water reservoir, making it an interesting spot for history lovers."
    },
    {
        "title": "Siddharth Garden and Zoo",
        "description": "A perfect place for families and nature lovers, Siddharth Garden and Zoo features lush greenery, a variety of wildlife, and well-maintained picnic spots. Visitors can see tigers, leopards, crocodiles, and exotic birds while enjoying a refreshing break from sightseeing."
    },
    {
        "title": "Aurangabad Caves",
        "description": "Lesser-known yet equally fascinating, the Aurangabad Caves are rock-cut Buddhist caves with intricate carvings and sculptures. These caves offer stunning panoramic views of the city and provide a quieter alternative to the more crowded Ajanta and Ellora Caves."
    },
    {
        "title": "Salim Ali Lake & Bird Sanctuary",
        "description": "Named after the famous ornithologist Dr. Salim Ali, this lake and bird sanctuary is a paradise for birdwatchers and nature enthusiasts. Visitors can spot various migratory and native bird species while enjoying a peaceful walk around the lake."
    },
    {
        "title": "Prozone Mall",
        "description": "For those looking for shopping and entertainment, Prozone Mall in Aurangabad offers a great mix of branded stores, restaurants, and a multiplex cinema. It’s an excellent place to relax and unwind after a day of exploring historical sites."
    }
],

"services": [
    {
      "name": "Mumbai to Aurangabad Cab Service by Vedant Travels",
      "description": "Traveling from Mumbai to Aurangabad? Vedant Travels offers comfortable and reliable cab services to ensure your journey is smooth and hassle-free. Whether you're traveling for leisure or business, our well-maintained vehicles and experienced drivers will make your trip enjoyable."
    },
    {
      "name": "Mumbai to Aurangabad Taxi",
      "description": "Book your Mumbai to Aurangabad taxi with Vedant Travels for a convenient and reliable ride. Our fleet of vehicles is perfect for long-distance journeys, providing comfort and efficiency throughout the trip."
    },
    {
      "name": "Mumbai to Aurangabad Car Hire",
      "description": "If you're looking for a car to hire for your trip from Mumbai to Aurangabad, Vedant Travels has a variety of options available. Whether you're traveling solo or with a group, we provide the ideal vehicle to suit your needs, ensuring a smooth and comfortable journey."
    },
    {
      "name": "Aurangabad Taxi Service",
      "description": "Vedant Travels offers premium Aurangabad taxi services, providing you with a comfortable, safe, and affordable way to explore the city. Our professional drivers are well-versed in the best routes, ensuring you have an efficient travel experience in Aurangabad."
    },
    {
      "name": "Mumbai to Aurangabad One Way Cab",
      "description": "Looking for a one-way trip from Mumbai to Aurangabad? Vedant Travels offers convenient one-way cab services, allowing you to travel directly to your destination without the hassle of return bookings. Our one-way cab service is cost-effective and perfect for a stress-free journey."
    },
    {
      "name": "Aurangabad Trip from Mumbai",
      "description": "Planning a trip from Mumbai to Aurangabad? Vedant Travels offers reliable and comfortable transportation services for your journey. We ensure your trip is enjoyable and hassle-free with our experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Mumbai to Aurangabad Innova",
      "description": "Travel in comfort and style with an Innova for your Mumbai to Aurangabad journey. Vedant Travels offers Innova cabs, providing extra space and luxury for your trip. Whether you're traveling with family or friends, the Innova is perfect for a comfortable and relaxed journey."
    },
    {
      "name": "Mumbai to Aurangabad Round Trip",
      "description": "Planning a round trip from Mumbai to Aurangabad? Vedant Travels offers round-trip taxi services to ensure a comfortable and seamless experience both ways. Enjoy the flexibility of choosing your schedule and rest assured that you'll have a pleasant journey."
    },
    {
      "name": "Aurangabad Cab Booking",
      "description": "Booking a cab from Aurangabad is easy with Vedant Travels. Whether you're booking for a one-way trip, a round trip, or a specific sightseeing tour, we offer flexible booking options to make your trip more convenient. Book your Aurangabad cab online or via phone for a smooth journey."
    },
    {
      "name": "Aurangabad Cab Fare",
      "description": "At Vedant Travels, we offer competitive and transparent pricing for your Aurangabad trip. Our cab fares are designed to be affordable while ensuring you travel comfortably. Contact us for an accurate fare quote based on the specifics of your journey."
    }
  ],



  "tableData": [
    ["Mumbai to Aurangabad Cab", "Mumbai to Aurangabad Taxi"],
    ["Mumbai to Aurangabad Car Hire", "Aurangabad Taxi Service"],
    ["Mumbai to Aurangabad One Way Cab", "Aurangabad Trip from Mumbai"],
    ["Mumbai to Aurangabad Innova", "Mumbai to Aurangabad Round Trip"],
    ["Aurangabad Cab Booking", "Aurangabad Cab Fare"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality, especially for long-distance travel. Our professional drivers ensure timely pickups and drop-offs from Mumbai to Aurangabad, making your journey smooth and stress-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a relaxing ride in our well-maintained, spacious vehicles designed for long-distance travel. With comfortable seating, ample legroom, air conditioning, and modern amenities, your journey will be comfortable throughout the entire trip."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our experienced drivers are trained in long-distance driving and are familiar with the best routes from Mumbai to Aurangabad. They ensure a safe, efficient, and smooth ride while adhering to all traffic regulations and safety protocols."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "At Vedant Travels, we offer affordable pricing with no hidden charges. Our transparent pricing ensures you know exactly what you’ll be paying for, with clear, upfront costs. You get great value for your money, with the best services at competitive rates."
    },
    {
      "WhyChooseheading": "Safe and Secure Journey",
      "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly inspected and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a worry-free ride."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether it’s an early morning start or a late-night arrival, Vedant Travels is available around the clock. Our customer service team is always ready to assist with booking or any travel-related inquiries, ensuring you can travel anytime."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Aurangabad cab is easy and convenient. You can book online through our website or mobile app, or you can contact our customer service team to assist you with your reservation and make arrangements as needed."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer personalized travel packages to suit your needs. Whether you're traveling for business or leisure, we can tailor your trip to fit your schedule and comfort. Let us know your preferences, and we’ll ensure everything is arranged for your convenience."
    }
  ]
    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Aurangabad cab with Vedant Travels?',
            answer: 'You can easily book your cab online through our website or mobile app. Alternatively, you can call our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Mumbai to Aurangabad trip?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All vehicles are equipped for comfort and safety, ensuring a pleasant journey.',
        },
        {
            id: 3,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced in handling long-distance journeys and are familiar with the best routes to ensure a smooth, safe, and timely ride from Mumbai to Aurangabad.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Aurangabad cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payment through our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Mumbai to Aurangabad?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details during the booking process, and we will handle the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours during the Mumbai to Aurangabad trip?',
            answer: 'Any additional charges for waiting or detours will be communicated to you upfront. We believe in complete transparency, with no hidden costs.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Aurangabad?',
            answer: 'Yes, we offer sightseeing tours in Aurangabad as part of your trip. Explore popular attractions like the Ajanta Caves, Ellora Caves, and Bibi Ka Maqbara with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Aurangabad cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra or special luggage needs, please inform us at the time of booking, and we will make necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel from Mumbai to Aurangabad?',
            answer: 'Yes, we offer corporate travel services for business trips to Aurangabad. Whether it’s a corporate meeting, conference, or event, we provide comfortable and professional services for your needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Aurangabad travel?',
            answer: 'Vedant Travels stands out for its reliable, affordable, and comfortable service. With experienced drivers, well-maintained vehicles, and transparent pricing, we ensure your travel from Mumbai to Aurangabad is safe, smooth, and hassle-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ramesh Desai",
            title: "Customer",
            quote: "I recently traveled from Mumbai to Aurangabad with Vedant Travels, and I had an excellent experience. The vehicle was comfortable, the driver was courteous, and the journey was smooth. I highly recommend their services for long-distance travel.",
            rating: 5,
        },
        {
            name: "Mrs. Shalini Kumar",
            title: "Customer",
            quote: "We used Vedant Travels for our family trip to Aurangabad. The cab was well-maintained, and the driver was professional and friendly. It made our trip so much more enjoyable and stress-free. We’ll definitely use them again for future trips.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
  
  
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Aurangabad Cab",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-aurangabad-cab.jpg",
  "description": "Book Mumbai to Aurangabad cab with Vedant Travels for a safe and comfortable journey to the historical city of Aurangabad. AC sedans, SUVs, and tempo travellers available for one-way and round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-aurangabad-cab"
  }
};



  
   
      


    return (
        <div>
           
           <Helmet>
  <title>Mumbai to Aurangabad Cab | Comfortable Historical Tours | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Aurangabad cab with Vedant Travels for a safe and comfortable journey to the historical city of Aurangabad. AC sedans, SUVs, and tempo travellers available for one-way and round trips." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Aurangabad Cab, Aurangabad Taxi from Mumbai, Vedant Travels Mumbai Aurangabad, AC Cab Mumbai Aurangabad, SUV Cab Mumbai Aurangabad, Historical Tour Cab Mumbai Aurangabad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/93.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoaurangabadcab;